<template>
  <div class="review">
      <div class="search">
            <el-date-picker
            style="margin-right:1%"
            v-model="startTime"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="销售日期">
            </el-date-picker>
        <span class="demonstration" style="line-height: 38px;font-size: 14px;">至</span>
            <el-date-picker
            style="margin-left:1%"
            v-model="endTime"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="销售日期">
            </el-date-picker>
          <el-input v-model="orderid" placeholder="订单号"></el-input>
          <el-input v-model="name" placeholder="客户姓名"></el-input>
          <el-input v-model="carnum" placeholder="车架号"></el-input>
          <el-input v-model="compay" placeholder="金融公司"></el-input>
          <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
      </div>
      <div class="tablelist">
          <el-table
            :data="tableData"
            :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
            style="width: 100%">
            <el-table-column
                prop="saleCode"
                label="订单号"
                width="200">
            </el-table-column>
            <el-table-column
                prop="name"
                width="100"
                label="车主姓名">
            </el-table-column>
            <el-table-column
               width="100"
                prop="phone"
                label="手机号">
            </el-table-column>
            <el-table-column
               width="120"
                prop="carModelOne"
                label="汽车车型">
                <template slot-scope="scope">
                    {{scope.row.carModelOne + scope.row.carModelTwo}}
                </template>
            </el-table-column>
            <el-table-column
               width="120"
                prop="vin"
                label="车架号">
            </el-table-column>
            <el-table-column
               width="120"
                prop="productName"
                label="产品名称">
            </el-table-column>
            <el-table-column
               width="120"
                prop="saleType"
                label="订单类型">
                <template slot-scope="scope">
                   {{scope.row.saleType == 1 ?'销售':scope.row.saleType == 2?'续费':'销售'}}
                </template>
            </el-table-column>
             <el-table-column
               width="100"
                prop="clearingFormType"
                label="支付方式">
                <template slot-scope="scope">
                    {{scope.row.clearingFormType == 1 ? '月结': scope.row.clearingFormType == 2?'预付款':'扫码付款'}}
                </template>
            </el-table-column>
             <el-table-column
               width="100"
                prop="sale"
                label="作废状态">
                <template slot-scope="scope">
                    {{scope.row.revokeState == 1?'待审核':scope.row.revokeState == 2?'已作废':scope.row.revokeState == 3?'未作废':'未作废'}}
                </template>
            </el-table-column>
            <el-table-column
            width="150"
                prop="submitDate"
                label="提交日期">
            </el-table-column>
             <el-table-column
               width="150"
                prop="paymentDate"
                label="销售日期">
            </el-table-column>
            <el-table-column
                prop=""
                width="200"
                label="操作">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="look(scope.row)">查看</el-link>
                    <el-link :underline="false" @click="onloadpdf(scope.row)" :disabled="isDisable">下载PDF</el-link>
                    <el-link :underline="false" @click="news(scope.row)">创建新单</el-link>
                    <el-link :underline="false" @click="renew(scope.row)">续费</el-link>
                    <el-link v-if="scope.row.revokeState == 0 || scope.row.revokeState == 3" :underline="false" @click="viod(scope.row)">申请作废</el-link>
                </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="page">
          <el-pagination
            :background="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
      </div>
      <!-- 申请作废 -->
      <el-dialog
        title="申请作废"
        :visible.sync="dialogVisibleviod"
        :close-on-click-modal="false"
        width="30%"
        >
       <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="作废理由" prop="desc">
                <el-input type="textarea" v-model="ruleForm.desc"></el-input>
            </el-form-item>
       </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button  v-preventReClick @click="dialogVisibleviod = false">取 消</el-button>
            <el-button  v-preventReClick type="primary" @click="submitForm()">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import {getselllist,afreshSubmit,renew} from '../axios/api'
export default {
    data(){
        return{
            orderid:'',
            name:'',
            carnum:'',
            compay:'',
            value2: '',
            tableData:[],
            currentPage4: 1,
            total:0,
            page:1,
            dialogVisibleviod:false,
            ruleForm: {
                desc: ''
            },
            rules: {
                desc: [
                    { required: true, message: '请填写作废理由', trigger: 'blur' }
                ]
            },
            startTime:'',
            endTime:'',
            saleId:'',
            states:0,
            onloadpdfs:true,
            isDisable: false
        }
    },
    created(){
        this.getdata()
    },
    methods:{
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            this.getdata()
            if(this.states == 0){
                this.getdata()
            }else{
                this.search1()
            }
        },
        look(row){
            this.$router.push({
                name:'订单详情',
                params:{
                    code:row.saleCode,
                    id:row.id
                }
            })
        },
        viod(row){
            console.log(row)
            this.saleId = row.saleId
            this.dialogVisibleviod = true
            this.ruleForm.desc = ''
        },
        submitForm(){
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    var {data:dt} = await afreshSubmit({
                        id:this.saleId,
                        revokeApplyReason:this.ruleForm.desc,
                        revokeAuditUser:window.localStorage.getItem('shopId'),
                        isResubmit:'1'
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message.success(dt.message)
                        this.dialogVisibleviod = false
                        this.getdata()
                    } 
                } 
            });
        },
        async getdata(){
            this.states = 0
            var {data:dt} = await getselllist({
                current:this.page,
                limit:10,
                state:5,
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        },
        async search(){
            this.states = 1
            var {data:dt} = await getselllist({
                startPaymentDate:this.startTime,
                endPaymentDate:this.endTime,
                code:this.orderid,
                name:this.name,
                vin:this.carnum,
                financialCompany:this.compay,
                state:5,
                current:1,
                limit:10,
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.page = 1
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        },
        async search1(){
            this.states = 1
            var {data:dt} = await getselllist({
                startPaymentDate:this.startTime,
                endPaymentDate:this.endTime,
                code:this.orderid,
                name:this.name,
                vin:this.carnum,
                financialCompany:this.compay,
                state:5,
                current:this.page,
                limit:10,
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.page.total
                this.tableData = dt.data.page.records
            }
        },
        news(row){
            console.log(row)
            this.$router.push({
                name:'销售信息录入',
                params:{
                    all:row,
                    flagnews:true
                }
            })
        },
        onloadpdf(row){
           console.log(row)
           this.isDisable = true
           this.$message.success('已开始下载，请耐心等待')
           window.location.href=`http://1.95.5.134:8088/pdf/${row.id}`
           setTimeout(() => {
               this.isDisable = false
           },20000)    
        },
        renew(row){
            console.log(row)
            this.$confirm('确认创建续费订单吗，续费订单的保险年限只能为1年!', '续费', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal:false,
                type: 'warning'
                }).then(async () => {
                    var {data:dt} = await renew({
                        code:row.code
                    })
                    console.log(dt)
                    if(dt.code == 200){
                        this.$message({
                            type: 'success',
                            message: '续费申请提交成功'
                        });
                        this.getdata()
                    }   
                }).catch(() => {
                
            });
        }
    }
}

</script>
<style lang="less" scoped>
.review{
   background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link.el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    } 
}
</style>
<style>
.el-date-range-picker{
        z-index: 9999999!important;
}
.el-date-range-picker__editors-wrap .el-date-range-picker__time-picker-wrap:nth-child(2){
    display: none;
    /* display: ; */
}
</style>